import { render, staticRenderFns } from "./reInterviewRecordItem.vue?vue&type=template&id=21237569&scoped=true"
import script from "./reInterviewRecordItem.vue?vue&type=script&lang=js"
export * from "./reInterviewRecordItem.vue?vue&type=script&lang=js"
import style0 from "./reInterviewRecordItem.vue?vue&type=style&index=0&id=21237569&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21237569",
  null
  
)

export default component.exports